import { Compartment, EditorState } from '@codemirror/state';
import { EditorView, lineNumbers } from '@codemirror/view';
import { syntaxHighlighting } from '@codemirror/language';
import { dbtChartsHighlightStyle, dbtChartsYamlLanguage } from 'codemirror-dbt-charts';
import * as state from './state.js';

// yaml gets the shared dbt charts YAML+SQL language; json/text stay plain text
// (no @codemirror/lang-json — out of scope for this migration).
const languageCompartment = new Compartment();

export function formatCodePreviewContent(content, format) {
    if (format === 'json') {
        try {
            return JSON.stringify(JSON.parse(content), null, 2);
        } catch {
            return content;
        }
    }
    return content;
}

/** Read-only code-preview EditorView, mounted once by editor.js. */
export function createCodePreview(parent) {
    return new EditorView({
        doc: '',
        parent,
        extensions: [
            lineNumbers(),
            syntaxHighlighting(dbtChartsHighlightStyle),
            EditorState.readOnly.of(true),
            languageCompartment.of([]),
        ],
    });
}

export function showCodePreview(content, format) {
    const previewContent = document.getElementById('preview-content');
    previewContent.style.display = 'none';
    // Empty it, don't just hide it: a leftover spinner in there still answers
    // isPreviewLoading() with a render that finished long ago.
    previewContent.innerHTML = '';
    const el = document.getElementById('code-preview');
    el.classList.add('is-visible');
    const languageExtension = format === 'yaml' ? dbtChartsYamlLanguage(state.sqlBlocks) : [];
    const text = formatCodePreviewContent(content, format);
    state.codePreview.dispatch({
        changes: { from: 0, to: state.codePreview.state.doc.length, insert: text },
        effects: languageCompartment.reconfigure(languageExtension),
    });
    requestAnimationFrame(() => state.codePreview.requestMeasure());
}

export function showVisualPreview() {
    const el = document.getElementById('code-preview');
    el.classList.remove('is-visible');
    document.getElementById('preview-content').style.display = '';
}
